import styles from "./Layout.module.css";
import LeftSidebar from "../sidebar/LeftSidebar";
import PageContent from "../pageContent/PageContent";
import { useSelector } from "react-redux";
import Loader from "../loader/Loader";
import OverlayLoader from "../loader/OverlayLoader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FeedbackButton from "../feedback/FeedbackButton";
import FeedbackDialog from "../dialog/FeedbackDialog";
import {
  CLIENT_ADMIN_ROLE_ID,
  VF_ADMIN_ROLE_ID,
} from "../../constants/constant";
import ResponsiveLoader from "../loader/ResponsiveLoader";

const Layout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("bb_access_token");
  const searchParams = localStorage.getItem("searchParams");
  const loading = useSelector((state) => state?.overlay?.overlayShowing);
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);
  const isUserReview = window.location.href.includes("user-review");
  const isSetupOrganisation =
    window.location.href.includes("setup-organisation");

  useEffect(() => {
    if (!token) {
      navigate("/home");
    }
  }, [token]);

  const handleClose = () => {
    setOpen(false);
  };

  if (!currentUser) return <Loader />;
  return (
    <>
      <OverlayLoader loading={loading} />
      <ResponsiveLoader loading={loading} />
      <div className={styles.clientAdminDashboardNew1}>
        {!(isUserReview || isSetupOrganisation) && <LeftSidebar />}
        <PageContent />
        {((searchParams === "/admin" && isClientAdmin && !isVfAdmin) ||
          searchParams === "/") && (
          <>
            <FeedbackButton setOpen={setOpen} />
            <FeedbackDialog
              open={open}
              setOpen={setOpen}
              handleDone={handleClose}
              title="Feedback"
              leftButtonText="Cancel"
              rightButtonText="Submit"
            />
          </>
        )}
      </div>
    </>
  );
};

export default Layout;
